<template>
  <MainFilter
    :filterTitle="`${t('title.repurpose')} - ${quantities} ${t(
      'title.products'
    )}`"
    :filterText="t('paragraph.repurpose')"
    :filterQuery="filterQuery"
    v-model:defaultFilter="filter"
    v-model:defaultSortingSettings="sortingSettings"
    :translateHeaders="translateHeaders"
    :productStatus="presetFilter.status"
    :pdfRoute="'to-repurpose'"
    :hasProducts="quantities > 0"
  />
  <ProductTable
    :actionStatuses="['CP', 'F', 'R', 'KC', 'CA']"
    :noRowsText="t('label.noRowsPositive')"
    v-model:filter="filter"
    :sortingSettings="sortingSettings"
    :translateHeaders="translateHeaders"
    :presetFilter="presetFilter"
  />
</template>

<script setup lang="ts">
import MainFilter from "@/components/filter/MainFilter.vue";
import { computed, Ref, ref, defineProps, withDefaults } from "vue";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { FilterOptions, PresetFilter } from "../library/types/filter/filter";
import { SortingSettings } from "../library/types/sorting/sorting";
import { useIndexStore } from "@/store";
import ProductTable from "@/components/table/ProductTable.vue";
import { useI18n } from "vue-i18n";

type ProjectRepurposeProps = {
  filterQuery?: string;
};

withDefaults(defineProps<ProjectRepurposeProps>(), {
  filterQuery: ""
});

const indexStore = useIndexStore();
const { t } = useI18n();
const sortingSettings: Ref<SortingSettings> = ref({
  col: "updated_at",
  asc: false
});
const translateHeaders = [
  "levkod",
  "kategori_id",
  "skick2",
  "rum",
  "till_rum",
  "main_category"
];
const filter: Ref<FilterOptions> = ref({
  categories: {},
  intervals: {}
});
const presetFilter: PresetFilter = {
  filter: [],
  group: ["benamn", "levkod", "besk", "kategori_id", "green_hash"],
  status: ["Å"]
};

const quantities = computed(() => {
  return indexStore.quantities ? indexStore.quantities.Å : 0;
});
</script>
